import { render } from "./sf-link.vue?vue&type=template&id=6513e403&scoped=true"
import script from "./sf-link.vue?vue&type=script&lang=js"
export * from "./sf-link.vue?vue&type=script&lang=js"

import "./sf-link.vue?vue&type=style&index=0&id=6513e403&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6513e403"]])

export default __exports__